<template>
    <div class="col-sm-12 top-menu z-3">
        <router-link to="/">
            <div class="logo-container">
                <img alt="Processos Seletivos" src="../assets/img/logo.png" class="logo-img">
            </div>
        </router-link>

        <div class="user-container text-center vertical-center" v-if="getUserData().username">
            <i class="fa fa-user-circle user-icon"></i>
            <i class="fa fa-ellipsis-v fa-2x m-l-15 m-t-4 text-gray cursor-pointer"
               @click="(event) => {showOptionsMenu = !showOptionsMenu; event.stopPropagation()}"></i>
        </div>

        <div class="top-items" v-if="getUserData().username">
            <div>
                <span class="text-bold text-lg">{{ getUserData().name }}</span><br/>
                <span class="text-gray">{{ getUserData().institutionName }}</span>
            </div>
        </div>
    </div>
    <div class="options-menu" :class="showOptionsMenu ? 'show-menu' : ''"
         v-click-outside="() => {showOptionsMenu = false}">
        <p v-if="getUserData().institutionSlug">
            <router-link to="/user/edit/me/" class="text-black cursor-pointer">Minha conta</router-link>
        </p>
        <p v-else>
            <router-link to="/user/edit/candidate/" class="text-black cursor-pointer">Minha conta</router-link>
        </p>
        <p v-if="getUserData().institutionSlug">
            <router-link to="/user/list" class="text-black cursor-pointer">Administrar usuários</router-link>
        </p>
        <p v-if="getUserData().institutionSlug">
            <router-link to="/processes/list" class="text-black cursor-pointer">Meus processos</router-link>
        </p>
        <p>
            <router-link to="/subscriptions" class="text-black cursor-pointer">Minhas inscrições</router-link>
        </p>
        <p v-if="getUserData().institutionSlug">
            <router-link to="/user/account" class="text-black cursor-pointer">Minha carteira</router-link>
        </p>
        <p class="text-red cursor-pointer m-0 m-t-10" @click="logout()">
            <i class="fa fa-sign-out"></i>
            Sair
        </p>
    </div>
</template>

<script>
    import {cleanTokenCookie, getUserData, setUserData} from "../utils";

    export default {
        name: 'TopMenu',
        data() {
            return {
                showOptionsMenu: false
            }
        },
        methods: {
            getUserData: getUserData,
            logout() {
                cleanTokenCookie();
                setUserData({});
                window.location.assign(window.location.origin + '/#/login');
                window.location.reload();
            }
        }
    }
</script>

<style scoped>
    .top-menu {
        height: 70px;
        background: white;
        float: none;
        position: fixed;
        top: 0
    }

    .logo-img {
        height: 45px;
    }

    .top-menu > div {
        height: 70px;
        display: flex;
        justify-content: center;
        flex-direction: column;
    }

    .top-menu > a > div {
        height: 70px;
        display: flex;
        justify-content: center;
        flex-direction: column;
    }

    .logo-container {
        float: left;
        text-align: center;
    }

    .top-items {
        float: right;
        text-align: right;
        color: #323232;
        margin-right: 10px;
        display: block;
    }

    .user-container {
        width: 70px;
        float: right;
        flex-direction: row !important;
    }

    .user-container img {
        width: 60px;
    }

    .user-icon {
        font-size: 40px;
        color: #272776;
    }

    .top-items span {
        margin: auto 0;
        float: right
    }

    .options-menu {
        position: absolute;
        background-color: #F9F9F9;
        right: 15px;
        top: 70px;
        z-index: 5;
        padding: 15px;
        opacity: 0;
        height: 0;
        transition: 0.3s all ease;
        box-shadow: 0 0 5px 5px rgba(50, 50, 50, 0.2);
        border-radius: 5px;
        font-weight: bold;
        width: 180px;
        visibility: hidden;
    }

    .show-menu {
        height: unset;
        opacity: 1;
        visibility: visible;
    }

    a {
        text-decoration: none;
    }
</style>
